import { CheckOutlined } from "@ant-design/icons";
import { Select } from "antd";
import classNames from "classnames";
import {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import HBIcon from "../HBIcon";
import styles from "./index.module.less";
import InputWrap from "./wrap";
const { Option } = Select;
/**
 *
 * @param {{optLabel?: string, optKey?: string, optValue?: string} & import('antd').SelectProps} props 和antd下拉框一致
 * @param {boolean} props.noWrapper 是否需要外边框
 */
function HBSelect(props, ref) {
  const {
    placeholder = "请输入",
    optKey,
    optLabel,
    optValue,
    noWrapper = false,
    options = [],
    dropdownClassName,
    wrapClassName,
    ...other
  } = props;
  const [isFocus, setFocus] = useState(false);

  const [isFilled, setFilled] = useState(!!props?.value);

  const [selected, setSelected] = useState(props?.value);

  const selectRef = useRef(null);

  useImperativeHandle(ref, () => ({
    setFocus,
    ...selectRef.current,
  }));

  useEffect(() => {
    setFilled(props?.value !== undefined);
    setSelected(props?.value);
  }, [props.value]);

  return (
    <InputWrap
      className={wrapClassName}
      isFocus={isFocus}
      placeholder={placeholder}
      isFilled={isFilled}
      noWrapper={noWrapper}
      isDisabled={props.disabled}
    >
      <Select
        ref={selectRef}
        {...other}
        suffixIcon={
          <HBIcon type="ic_arrow_down" className={styles.selectArrow} />
        }
        bordered={false}
        dropdownClassName={classNames([styles.dropdown, dropdownClassName])}
        optionLabelProp="label"
        placeholder={noWrapper ? placeholder : null}
        onFocus={() => {
          setFocus(true);
        }}
        onBlur={() => {
          setFocus(false);
        }}
        onChange={(...arg) => {
          if (arg[0]) {
            setFilled(true);
          } else {
            setFilled(false);
          }
          if (props.onChange) {
            props.onChange(...arg);
          }
        }}
        onSelect={(...arg) => {
          const value = arg[0];
          setSelected(value);

          if (props.onSelect) {
            props.onSelect(...arg);
          }
        }}
      >
        {renderOptions(
          options,
          selected,
          optValue,
          optLabel,
          optKey,
          props.mode
        )}
      </Select>
    </InputWrap>
  );
}

/**
 * 渲染下拉框选项
 * @param { Array } options {
 *    value: String|Number,
 *    label: String,
 *    isSelected: Boolean || undefined
 * }}
 * @returns
 */
function renderOptions(options, selected, optValue, optLabel, optKey, mode) {
  let optValueStr = optValue || "value";
  let optLabelStr = optLabel || "label";
  let optKeyStr = optKey || "value";

  return options.map((option) => (
    <Option
      className={styles.option}
      value={option[optValueStr]}
      key={option[optKeyStr]}
      label={option[optLabelStr]}
    >
      <span>{option[optLabelStr]}</span>

      {option[optValueStr] === selected && mode !== "multiple" ? (
        <CheckOutlined />
      ) : (
        ""
      )}
    </Option>
  ));
}
/**
 * @param {import('antd').SelectProps} props 和antd下拉框一致
 * @param {boolean} props.noWrapper 是否需要外边框
 * @returns {JSX.Element}
 */
export default forwardRef(HBSelect);
